import microuniversoApi from "app/api/microuniversoApi"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { FiltroMovimentacaoEstoque } from "app/types/produto/FiltroMovimentacaoEstoque"
import { tratamentoErroPadrao } from "app/use-cases"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { Filial, ListaTipo, MovimentacaoEstoque, MovimentacaoEstoques } from "./MovimentacaoEstoque"
import { Parametro } from "app/types/Parametro";
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto"


export type MovimentacaoEstoqueContainerProps = {
    item: IItemOrcamento,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string, () => void>,
    foraOrcamento: boolean
}

export const MovimentacaoEstoqueContainer = (props: MovimentacaoEstoqueContainerProps) => {
    const [filiais, setFiliais] = useState<Filial[]>()
    const [listaTpo, setListaTpo] = useState<ListaTipo[]>([])
    const [movimentacaoEstoque, setMovimentacaoEstoque] = useState<MovimentacaoEstoque[]>([])
    //const [parametros, setParametros] = useState<Parametro[]>([])
    const [filtros, setFiltros] = useState<FiltroMovimentacaoEstoque>({
        codigoProduto: props.item.Codigo,
        filtroDataFim: "",
        filtroDataInicio: "",
        listaTpo: [],
        pesquisarTpo: false,
        filial: null
    })

    const isMounted = useRef(true);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)


    const onObterDadosMovimentacaoEstoque = useCallback(async (filtrosMovimentacao: FiltroMovimentacaoEstoque) => {
        globalMU.blockUI();
        try {
            setFiltros(filtrosMovimentacao)
            const resultado = await microuniversoApi.Produto.dadosMovimentacaoEstoque(filtrosMovimentacao);

            if (isMounted.current) {
                if (resultado) {
                    if (("Errors" in resultado || "HasErrors" in resultado || resultado?.length == 0)) {
                        setMovimentacaoEstoque([]);
                        globalMU.showWarnMessage("Nenhum registro encontrado para os filtros informados.")
                    } else {
                        setMovimentacaoEstoque(resultado)
                    }
                }
            }
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            if (isMounted.current) {
                globalMU.unblockUI();
            }
        }
    }, []);

    const onListarFiliais = useCallback(async () => {
        globalMU.blockUI();
        try {
            const dadosFiliais = await microuniversoApi.Produto.listarFiliais();
            if (isMounted.current) {
                setFiliais(dadosFiliais)
            }
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            if (isMounted.current) {
                globalMU.unblockUI();
            }
        }
    }, []);

    const onListarTposPorAtributo = useCallback(async (atributo: string) => {
        try {
            if (atributo.length < 3) {
                return
            }
            const dadosTposPorAtributo = await microuniversoApi.Produto.dadosTposPorAtributo(atributo);
            if (isMounted.current) {
                setListaTpo(dadosTposPorAtributo)
            }
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
    }, []);

    const onVoltar = useCallback(() => {
        props.onRemover()
        props.onVoltar()
    }, [props.onRemover, props.onVoltar]);

    const onPassoSelecionado = useCallback((passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }, [props.onRemover, passosInterno]);

    // const atualizarParametros = async () => {
    //     setParametros(
    //         await obterParametros({
    //             nomes: [
    //                 "CHAVE_MOVIMENTACAO_ORCAMENTO"
    //             ]
    //         })
    //     )
    // }

    // const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    useEffect(() => {
        isMounted.current = true;
		passosInterno.current.set("Movimentação Estoque", () => { renderizarComponentReact(<MovimentacaoEstoqueContainer {...props} />, "conteudo-pagina", true) })
        onListarFiliais();
        //atualizarParametros();

        return () => {
            isMounted.current = false;
        }
    }, [onListarFiliais]);

    const codigoProdutoExibicao = (props.item.CodigoProdutoExibicao || "").trimEnd();

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                id="MovimentacaoEstoqueContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}

            />
            <MovimentacaoEstoques
                movimentacaoEstoque={movimentacaoEstoque}
                filtroMovimentacaoEstoque={filtros}
                onPesquisar={onObterDadosMovimentacaoEstoque}
                codigo={ codigoProdutoExibicao != ""  ? codigoProdutoExibicao : props.item.CodigoProduto.trimEnd() }
                descricao={props.item.Descricao}
                filiais={filiais}
                listaTpo={listaTpo}
                onListarTposPorAtributo={onListarTposPorAtributo}
            />

        </>
    )
}